<template>
  <div class="lv_flexalign_center act_layout">
    <div
      class="act_button"
      :class="{ actived: actived === '' }"
      @click="
        actived = '';
        changeLayer('top')
      "
    >
      置顶
    </div>
    <div
      class="act_button"
      :class="{ actived: actived === 2 }"
      @click="
        actived = 2;
        changeLayer('up')
      "
    >
      上移
    </div>
    <div
      class="act_button"
      :class="{ actived: actived === 3 }"
      @click="
        actived = 3;
        changeLayer('down')
      "
    >
    下移
    </div>
    <div
      class="act_button"
      :class="{ actived: actived === 4 }"
      @click="
        actived = 4;
        changeLayer('bottom')
      "
    >
    置底
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      actived: "",
    };
  },
  methods: {
    changeLayer(action) {
      this.$bus.$emit(
        "setCoverage",
        action
      );
    },
  },
};
</script>

<style>
</style>